export default __webpack_public_path__ + "static/media/Ies_Signify.09456347.png";